import { clsx } from 'clsx'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

export default function Badge({ 
  children, 
  variant = 'default',
  size = 'md',
  className = '' 
}) {
  const { isAdminAppUI } = useLayoutVariant()

  const variants = {
    default: isAdminAppUI ? 'bg-[#1f2d40] text-[#7a8fa6]' : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200',
    primary: isAdminAppUI ? 'bg-[rgba(0,200,150,0.12)] text-[#00c896]' : 'bg-gradient-to-r from-primary-100 to-primary-200 dark:from-primary-900/30 dark:to-primary-800/30 text-primary-800 dark:text-primary-200 shadow-sm',
    success: isAdminAppUI ? 'bg-[rgba(102,187,106,0.12)] text-[#66bb6a]' : 'bg-gradient-to-r from-green-100 to-green-200 dark:from-green-900/30 dark:to-green-800/30 text-green-800 dark:text-green-200 shadow-sm',
    warning: isAdminAppUI ? 'bg-[rgba(255,183,77,0.12)] text-[#ffb74d]' : 'bg-gradient-to-r from-yellow-100 to-yellow-200 dark:from-yellow-900/30 dark:to-yellow-800/30 text-yellow-800 dark:text-yellow-200 shadow-sm',
    danger: isAdminAppUI ? 'bg-[rgba(239,83,80,0.12)] text-[#ef5350]' : 'bg-gradient-to-r from-red-100 to-red-200 dark:from-red-900/30 dark:to-red-800/30 text-red-800 dark:text-red-200 shadow-sm',
    info: isAdminAppUI ? 'bg-[rgba(79,195,247,0.12)] text-[#4fc3f7]' : 'bg-gradient-to-r from-blue-100 to-blue-200 dark:from-blue-900/30 dark:to-blue-800/30 text-blue-800 dark:text-blue-200 shadow-sm',
    purple: isAdminAppUI ? 'bg-[rgba(179,157,219,0.12)] text-[#b39ddb]' : 'bg-gradient-to-r from-purple-100 to-purple-200 dark:from-purple-900/30 dark:to-purple-800/30 text-purple-800 dark:text-purple-200 shadow-sm',
    indigo: isAdminAppUI ? 'bg-[rgba(95,136,221,0.12)] text-[#5f88dd]' : 'bg-gradient-to-r from-indigo-100 to-indigo-200 dark:from-indigo-900/30 dark:to-indigo-800/30 text-indigo-800 dark:text-indigo-200 shadow-sm',
  }

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  }

  return (
    <span className={clsx(
      isAdminAppUI
        ? 'inline-flex items-center font-medium rounded-full transition-all duration-200'
        : 'inline-flex items-center font-semibold rounded-full transition-all duration-300 hover:scale-105',
      variants[variant],
      sizes[size],
      className
    )}>
      {children}
    </span>
  )
}

